import {useState, ReactNode} from "react";
import {motion, AnimatePresence} from "framer-motion";

export type Tab = {
  label: string;
  content: ReactNode;
};

type TabSectionBlkProps = {
  title?: string;
  tabs: Tab[];
  className?: string;
};

const TabSectionBlk = ({title, tabs, className}: TabSectionBlkProps) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="main-container-blk">
      <div className={`tab-section-blk ${className || ""}`}>
        {title && <h2 className="tab-section-title">{title}</h2>}
        <div className="tab-section-container">
          <div className="tab-section-tabs">
            {tabs.map((tab, index) => (
              <button
                key={tab.label}
                className={`tab-section-tab ${
                  activeTab === index ? "active" : ""
                }`}
                onClick={() => setActiveTab(index)}>
                {tab.label}
              </button>
            ))}
          </div>
          <div className="tab-section-content">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                initial={{opacity: 0, y: 10}}
                animate={{opacity: 1, y: 0}}
                exit={{opacity: 0, y: -10}}
                transition={{duration: 0.3, ease: "easeInOut"}}>
                {tabs[activeTab].content}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabSectionBlk;
